module.exports = __webpack_public_path__ + "static/media/dream.43a5b61d.jpg";